
define('text!modules/admin/myOrgs/advertiser/templates/createEdit.html',[],function () { return '<div class="w-box w-Admin w-CreateEditForm">\n  <div class="w-head create-edit-head">\n    {{>header}}\n  </div>\n  <div class="w-body w-Advertiserx">\n    {{>body}}\n  </div>\n  {{>footer}}\n</div>\n';});

